export function setYearFirst(state, res) {
  const { data = '' } = res;
  state.year = data;
  state.loadYear = false;
}

export function setStatusList(state, data) {
  state.statusList = data;
}
